import { appSettings } from "../app/settings";

type TStaticImages = {
  videoPreview: string;
};

export const STATIC_IMAGES: TStaticImages = {
  videoPreview: "/assets/logos/logo_light_protective.png"
};

export const CATEGORY_IMAGE_OBJECTFIT: "cover" | "contain" = "contain";

export const FALLBACK_PRODUCT_IMAGE = appSettings.chFallbackImageUrl;
export const CONTACT_PERSON_IMAGE =
  "https://hsr-p-001.sitecorecontenthub.cloud/api/public/content/cacc8f88cfee46829c849bc229bee427?v=0854cd54";
